import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ButtonModule } from '../../button/button.module';
import { IconModule } from '../../icon/icon-module';
import { SearchBoxModule } from '../../search-box/search-box.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { GroupedMultiSelectDropdownComponent } from './grouped-multi-select-dropdown.component';

@NgModule({
  declarations: [GroupedMultiSelectDropdownComponent],
  imports: [CommonModule, SearchBoxModule, PipesModule, CheckboxModule, IconModule, ButtonModule],
  exports: [GroupedMultiSelectDropdownComponent],
})
export class GroupedMultiSelectDropdownModule {}
